import React, { useRef, navigation } from 'react';
import './Reporte.css';
import { LineReduccion } from "../components/LineReduccion";
import { dataPie, imgDona } from './Home';
import { useReactToPrint } from 'react-to-print'
import Navbar from '../components/Navbar';
import { Link, Navigate } from 'react-router-dom';

function Reporte( props ) {

  const componentRef = useRef();
  const [sidebar, setSidebar] = React.useState(false);
  const showSidebar = () => setSidebar(!Navbar.sidebar);
  const [showReporte, setShowReporte] = React.useState(false)

  const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];

  const today = new Date();
  const current = `${ months[today.getMonth()]} ${today.getDate()} de ${today.getFullYear()}`;

  React.useEffect(()=>{
    document.getElementsByClassName('navbar')[0].style.display = 'none';
  },[])

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className='reporte' ref={componentRef}>
      <div style={{display:'flex'}}>
          <img src='/Logo_blanco.svg' className='login__logo' alt='Carbonbox logo'></img>
          <div style={{marginTop:'20px',fontSize:'1.5rem', width:'100%', display:'block', textAlign:'right'}}>
            <label style={{display:'block'}}>Fibtex</label>
            <span>{current}</span>
          </div>
      </div>
      <div>
        <h3>Reporte de emisiones de dióxido de carbono equivalente en un año</h3>
        <h3> cabono y estándares de medición</h3>    
      </div>
      <div style={{display:'flex', width:'100%'}}>
        <div style={{textAlign:'left',display:'block', width:'100%'}}>
          
          <Link className='button__generar__reporte' to="/home">Home</Link>
        </div>
        <div style={{textAlign:'right', display:'block', width:'100%'}}>
          <button className='button__generar__reporte' onClick={handlePrint}>Generar reporte</button>
        </div>
      </div>
      
      <div style={{background:'white', color:'black', borderRadius:'4px'}}>
        <h3>Huella de carbono año</h3>
        <h3>porcentaje por categorías.</h3>
        <div style={{width:'600px',height:'400px'}}>
          <img src={imgDona} alt='gráfica por categorías'></img>
        </div>

        <br/>
        
      </div>
    </div>
  )
}

export { Reporte };
